export const getThrough = (
  path: string,
  object: Record<string, any>,
  defaultValue = false
): any | boolean =>
  path?.split('.')?.reduce((prev, curr) => {
    return prev && prev?.[curr] !== undefined ? prev?.[curr] : defaultValue;
  }, object);
